// Lib
import { createSelector } from 'reselect';
import { activePopupSelector } from '../../components/popupPanel/popupOpenSelector';
import { PopupIds } from '../../components/popupPanel/popupConstants';

const UTIL_POPUP_IDS = [
    PopupIds.IMAGE_SEARCH,
    PopupIds.SEARCH,
    PopupIds.INSPIRATION,
    PopupIds.HELP,
    PopupIds.REMOTE_USERS,
    PopupIds.NOTIFICATION,
    PopupIds.NOTIFICATIONS,
    PopupIds.QUICK_NOTES,
    PopupIds.USER,
];

const isUtilPopup = (popupId) => UTIL_POPUP_IDS.indexOf(popupId) > -1;

export const getIsUtilPopupOpened = createSelector(activePopupSelector, (popupsMap) => {
    if (!popupsMap.size) return false;

    const activePopupId = popupsMap.keySeq().first();
    if (!isUtilPopup(activePopupId)) return false;

    return true;
});
